import type { CustomerProps } from '@/repositories/auth/AuthRepository.types';
import { jwtDecode } from 'jwt-decode';

export const getCPFFromToken = (authToken?: string) =>
  authToken
    ? jwtDecode<Pick<CustomerProps, 'document' | 'email'>>(authToken)?.document
    : '';

export const getSubFromToken = (authToken?: string) =>
  authToken
    ? jwtDecode<Pick<CustomerProps, 'document' | 'email' | 'sub'>>(authToken)
        ?.sub
    : '';
